'use strict';
var DataPointDirection;
(function (DataPointDirection) {
    DataPointDirection["Row"] = "row";
    DataPointDirection["Column"] = "column";
})(DataPointDirection || (DataPointDirection = {}));
export default DataPointDirection;
